import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

/**
 * Consistent back navigation link used across the site.
 * Renders flush-left with the content grid — no pill shape, no extra padding.
 *
 * @param {string}          [label]   - Text to display (e.g. "Tournaments"). Omit for icon-only.
 * @param {string|number}   [to]      - Path string or -1 for history.back(). Defaults to -1.
 * @param {string}          [className] - Additional classes merged onto the wrapper.
 * @param {() => Promise<boolean|void>} [onBeforeNavigate] - Optional async hook
 *   awaited before navigating. If it resolves to `false`, navigation is
 *   suppressed (used by the seed editor to auto-save and only proceed if the
 *   save actually succeeded).
 */
export default function BackLink({ label, to = -1, className = '', onBeforeNavigate }) {
  const navigate = useNavigate()

  const handleClick = async () => {
    if (onBeforeNavigate) {
      const result = await onBeforeNavigate()
      if (result === false) return
    }
    navigate(to)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors font-medium cursor-pointer ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      {label && <span>{label}</span>}
    </button>
  )
}
